var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Where in the world?")]),_c('div',{staticClass:"split",on:{"click":_vm.changeTheme}},[_c('fa-icon',{staticClass:"icon",attrs:{"icon":['far', 'moon']}}),_c('span',[_vm._v("Dark Mode")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }